// extracted by mini-css-extract-plugin
module.exports = {"navbar-nav":"NavList_navbar-nav__1cbgg","nav-link":"NavList_nav-link__1KKQY","active-link":"NavList_active-link__2wPQL"};